<template>
  <div v-loading="loading">
    <el-table border :data="opvList" strip>
      <el-table-column
        prop="sname"
        :label="$t('lang.openvpn.name')"
      ></el-table-column>
      <el-table-column
        prop="recipe"
        :label="$t('lang.openvpn.recipe')"
      ></el-table-column>
      <el-table-column :label="$t('lang.openvpn.enabled')">
        <template slot-scope="scope">
          {{
            scope.row.enabled == 1
              ? $t("lang.openvpn.open")
              : $t("lang.openvpn.close")
          }}
        </template>
      </el-table-column>
      <el-table-column
        prop="port"
        :label="$t('lang.openvpn.port')"
      ></el-table-column>
      <el-table-column
        prop="proto"
        :label="$t('lang.openvpn.proto')"
      ></el-table-column>
      <el-table-column :label="$t('lang.openvpn.status')">
        <template slot-scope="scope">
          <span v-if="statusData.status == 0">{{ $t("lang.openvpn.no") }}</span>
          <span v-else>
            {{ $t("lang.openvpn.yes") }}({{ statusData.pid }})
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="ovpn_constatus"
        :label="$t('lang.openvpn.constatus')"
      ></el-table-column>
      <el-table-column :label="$t('lang.openvpn.start_stop')">
        <template slot-scope="scope">
          <el-button v-if="statusData.status == 0" @click="start">{{
            $t("lang.openvpn.start")
          }}</el-button>
          <el-button v-else @click="stop">{{
            $t("lang.openvpn.stop")
          }}</el-button>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.openvpn.operate')">
        <template slot-scope="scope">
          <el-button @click="editClick(scope)">{{
            $t("lang.openvpn.edit")
          }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <Opv ref="opv" @update="update" :opvData="opvData" :deviceSoftwareVer="deviceSoftwareVer"></Opv>
  </div>
</template>

<script>
import {
  updateConfig,
  listConfig,
  getNetworkInfo,
} from "@/api/configurationlist";
import { getProgressStatus, progressControl } from "@/api/particulars";
import Opv from "./components/opv.vue";
import { cloneDeep } from "lodash";
export default {
  name: "openvpn",
  props: ["deviceSn", "deviceDid", "deviceSoftwareVer"],
  data() {
    return {
      opvList: [],
      statusData: {},
      opvData: {},
      timer: null,
      loading: false,
    };
  },
  methods: {
    getConfig() {
      return new Promise((reslove, reject) => {
        let options = [
          { option: "nobind" },
          { option: "verb" },
          { option: "comp_lzo" },
          { option: "client" },
          { option: "proto" },
          { option: "port" },
          { option: "keepalive" },
          { option: "cipher" },
          { option: "nice" },
          { option: "dev_type" },
          { option: "server" },
          { option: "server_bridge" },
          { option: "compress" },
          { option: "auth_method" },
          { option: "enabled" },
          { option: "tun_ipv6" },
          { option: "username" },
          { option: "password" },
          { option: "recipe" },
          { option: "ca" },
          { option: "key" },
          { option: "cert" },
          { option: "username" },
          { option: "password" },
          { option: "comp_lzo" },
          { option: "nice" },
          { option: "dev_type" },
          { option: "secret" },
          { option: "pkcs12" },
          { option: "dh" },
          { option: "tls_crypt" },
          { option: "remote" },
        ];
        if (this.deviceSoftwareVer >= "v2.5.221125") {
          options = [
            ...options,
            { option: "auth" },
            { option: "enable_secret" },
            { option: "enable_tls_auth" },
            { option: "enable_tls_crypt" },
            { option: "enable_dh" },
            { option: "enable_pkcs12" },
            { option: "dev" },
            { option: "tls_auth" },
          ];
        }
        listConfig(this.deviceSn, this.deviceDid, [
          {
            section: "openvpn",
            config: "openvpn",
            options,
            lists: [
              {
                list: "remote",
              },
            ],
          },
        ]).then((res) => {
          res.data.data.mess[0].s_objects.forEach((v) => {
            if (v.lists.remote.length !== 0) {
              v.options.remote+= v.lists.remote.join(" ");
            }
            v.options.remote = v.options.remote.split(" ");
            if (!v.options.proto) v.options.proto = "udp";
            this.opvList = [
              {
                ...v.options,
                // ...v.lists,
                sname: v.sname,
              },
            ].map((v, index) => {
              if (this.opvList.length > 0) {
                v.ovpn_constatus = this.opvList[index].ovpn_constatus;
                return v;
              } else {
                return v;
              }
            });
          });
          getProgressStatus(this.deviceDid, this.deviceSn, {
            process: ["openvpn"],
          }).then((res) => {
            this.opvList = this.opvList.map((v) => {
              v.status = res.data.data.mess[0].status;
              if (v.status == 0) {
                v.ovpn_constatus = this.$t("lang.openvpn.noConnect");
              } else {
                v.ovpn_constatus = res.data.data.mess[0].ovpn_constatus
                  ? res.data.data.mess[0].ovpn_constatus
                  : this.$t("lang.openvpn.connecting");
              }
              v.client = v.client == 1 ? true : false;
              v.enabled = v.enabled == 1 ? true : false;
              v.nobind = v.nobind == 1 ? true : false;
              v.tun_ipv6 = v.tun_ipv6 == 1 ? true : false;
              v.auth_method = v.auth_method ? v.auth_method : "ca cert";
              v.cipher = v.cipher ? v.cipher : "AES-128-CBC";
              return v;
            });
            this.statusData = res.data.data.mess[0];
            reslove();
          });
        });
      });
    },
    editClick(e) {
      this.opvData = e.row;
      this.$refs["opv"].opvDialog = true;
    },
    update(e, v) {
      this.loading = true;
      let write_files = Object.values(e).filter((v) => v.content);
      let options = ((e) => {
        let data = {};
        e.forEach((v) => {
          data[v.file_name.slice(v.file_name.lastIndexOf(".") + 1)] =
            v.file_name;
        });
        return data;
      })(write_files);
      let opvList = [v].map((v) => {
        let obj = cloneDeep(v);
        delete obj.status;
        delete obj.sname;
        delete obj.ovpn_constatus;
        console.log(obj.remote);
        obj.remote = obj.remote.join(" ");
        obj.client = obj.client ? 1 : 0;
        obj.enabled = obj.enabled ? 1 : 0;
        obj.nobind = obj.nobind ? 1 : 0;
        obj.tun_ipv6 = obj.tun_ipv6 ? 1 : 0;
        return obj;
      });
      options = {
        ...opvList[0],
        ...options,
      };
      updateConfig(this.deviceSn, this.deviceDid, [
        {
          section: "openvpn",
          config: "openvpn",
          sname: "opv1",
          index: [0],
          action: 0,
          options,
          write_files,
        },
      ]).then(async (res) => {
        if (res.data.data.mess === 0) {
          this.$message({
            showClose: true,
            message: this.$t("lang.ConfigSetting.Successfulconfiguration"),
            type: "success",
          });
        } else {
          this.$message({
            showClose: true,
            message: this.$t("lang.ConfigSetting.Configurationerror"),
            type: "warning",
          });
        }
        await this.restart();
        await this.getConfig();
        this.loading = false;
      });
    },
    start() {
      progressControl(
        [{ process: "openvpn", action: "start", type: 0 }],
        String(this.deviceDid),
        this.deviceSn
      ).then(async (res) => {
        this.loading = true;
        this.$message({
          message: this.$t("lang.openvpn.actionOk"),
          type: "success",
          showClose: true,
        });
        await this.getConfig();
        this.loading = false;
      });
    },
    stop() {
      progressControl(
        [{ process: "openvpn", action: "stop", type: 0 }],
        String(this.deviceDid),
        this.deviceSn
      ).then(async (res) => {
        this.loading = true;
        this.$message({
          message: this.$t("lang.openvpn.stopOk"),
          type: "success",
          showClose: true,
        });
        await this.getConfig();
        this.loading = false;
      });
    },
    restart() {
      return new Promise((reslove, reject) => {
        progressControl(
          [{ process: "openvpn", action: "restart", type: 0 }],
          String(this.deviceDid),
          this.deviceSn
        ).then((res) => {
          reslove();
        });
      });
    },
  },
  mounted() {
    if (!this.timer) {
      this.timer = setInterval(() => {
        this.getConfig();
      }, 10000);
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  watch: {
    deviceSn: {
      async handler(newV) {
        this.loading = true;
        await this.getConfig();
        this.loading = false;
      },
      immediate: true,
    },
  },
  components: { Opv },
};
</script>
<style scoped></style>
